<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4" v-if="currentExperience">
          <div class="card-header pt-1 pb-0">
            <div>
              <h3 class="card-title text-primary mb-0">Experiencia {{ currentExperience.name }}</h3>
              <div class="sub-line"></div>
              <div class="row col-12 mt-3">
                <router-link :to="{ name: 'Experiencias' }"
                             class="col-md-2 col-6 col-md-offset-10 btn btn-primary btn-sm text-white bg-blue-600 rounded-lg hover:bg-blue-900 mb-0  ml-auto">
                  Ir al listado
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="card">
              <div class="card-body">
            <div class="row" v-if="currentExperience">
              <div class="col-md-6">
                <div>
                  <label class="form-control-label">
                    Nombre
                  </label>
                  <p>{{ currentExperience.name }}</p>
                </div>
                <div>
                  <label class="form-control-label">
                    Ruta
                  </label>
                  <p>{{ currentExperience.trail.name }}</p>
                </div>
              </div>
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="card-title"> Puntos de interés</h5>
                    </div>
                    <div class="card-body">
                      <ul class="list-unstyled">
                        <li class="row">
                          <div class="col-8 text-bold">
                            Nombre
                          </div>
                          <div class="col-4 text-bold">
                            <span class="text-sm ml-2">Tipo</span>
                          </div>
                        </li>
                        <li class="row mrow" v-for="point in currentExperience.points" :key="point.id">
                          <div class="col-8">
                            {{ point.name }}
                          </div>
                          <div class="col-4" v-if="point.type">
                            {{ point.type.name }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script setup>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";


     const route = useRoute();
     const store = useStore();

    const getCurrentExperience = async (id) => {
      return await store.dispatch("experience/getExperienceById", id);
    };

    const currentExperience = computed(() => store.state.experience.currentExperience);

    onMounted(()=> {
      getCurrentExperience(route.params.id)
    });


</script>
<style scoped lang="scss">
.pointrow{
  display: flex;
  justify-content: flex-end;
}
.mrow {
  border-top: 1px solid #d2d6da;
  padding-top: 5px;
  padding-bottom: 5px;
  align-items: center;
}
</style>
